<template>
  <div>
    <c-card reference="Climb > Contatos" title="Contatos">
      <template slot="icons">
        <icon class="icon" @click="abrirExportar" icon="file-export"></icon>
        <icon class="icon" @click="abrirFiltros" icon="filter">
          <span v-if="totalFilters" class="card-icons-alert"
            >@{{ totalFilters }}</span
          >
        </icon>
      </template>
      <span v-if="!contatos || contatos.length === 0" style="font-size: .9em; color: #6f6f6f;">
        Nenhum contato encontrado.
      </span>
      <c-list :items="contatos" class="mb-3">
        <template v-slot:items="item">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <div>
                <span
                  style="font-size: .9em; color: #222; font-weight: bold;"
                  >{{ item.data.nome }}</span
                > da <span style="font-size: .9em; color: #222; font-weight: bold;">{{ item.data.empresa }}</span>
              </div>
              <span style="font-size: .8em; color: #6f6f6f">{{
                item.data.email
              }}</span>
            </div>
          </div>
        </template>
      </c-list>
      <span class="card-divisor mb-3"></span>

      <div class="d-flex justify-content-between">
        <span style="font-size: .8em;font-weight: bold;">
          {{ (page - 1) * limit + 1 }} -
          {{ page * limit > totalRows ? totalRows : page * limit }} /
          {{ totalRows }}
        </span>
        <b-pagination
          v-model="page"
          :total-rows="totalRows"
          :per-page="limit"
          aria-controls="my-table"
          pills
          size="sm"
          class="mb-0"
          @change="loadContatos"
        ></b-pagination>
      </div>
    </c-card>

    <c-modal title="Filtro" v-model="modalFiltro" size="md">
      <template v-slot:buttons>
        <button @click="limparFiltros">Limpar</button>
        <button @click="filtrarContatos">Filtrar</button>
      </template>
      <b-row>
        <b-col>
          <b-form-group label-size="sm" label="Departamento">
            <b-form-select v-model="temporaryFilters.departamento_id" :options="optionsDepartamentos" class="mb-3">
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-size="sm" label="Cargo">
            <b-form-select v-model="temporaryFilters.cargo_id" :options="optionsCargos" class="mb-3">
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-size="sm" label="Profissão">
            <b-form-select v-model="temporaryFilters.profissao_id" :options="optionsProfissoes" class="mb-3">
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-size="sm" label="Uf">
            <b-form-select v-model="temporaryFilters.sig_uf" :options="optionsUf"  @change="loadMunic" class="mb-3">
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-size="sm" label="Municipio">
            <b-form-select v-model="temporaryFilters.cod_munic" :options="optionsMunic" class="mb-3">
              <template v-slot:first>
                <option :value="null">Selecione um</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>

    <c-modal title="Exportar" v-model="modalExportar" size="md">
        <div class="text-center mb-3">
            <b-form-group label-size="lg" label="Opções de Exportação:" label-for="opcoes-exportacao"></b-form-group>
            <button class="btn btn-primary btn-md mt-1 rounded-pill" @click="exportarContato">Padrão .CSV</button><br>
            <button class="btn btn-primary btn-md mt-1 rounded-pill" @click="exportarContatosSpotter">Padrão .XLSX</button>
        </div>
    </c-modal>
  </div>
</template>

<script>
import ContatosService from "@/services/ContatosService.js";
import departamentosService from "@/services/departamentosService.js";
import cargosService from "@/services/cargosService.js";
import profissoesService from "@/services/profissoesService.js";
import ufService from "@/services/ufService.js";
import municService from "@/services/municService.js";

import CList from "@/components/CList.vue";
import CCard from "@/components/CCard.vue";
import CModal from "@/components/CModal.vue";

import { mapActions } from "vuex";

export default {
  name: "Contatos",
  data() {
    return {
      contatos: [],
      contatosAll: [],
      contatosSpotter: [],
      departamentos: [],
      cargos: [],
      profissoes: [],
      uf: [],
      munic: [],
      commonFields: [
        { name: "Nome", attribute: "nome" },
        { name: "E-mail", attribute: "email" },
        { name: "Empresa", attribute: "empresa" }
      ],
      modalFiltro: false,
      modalExportar: false,
      temporaryFilters: {},
      loading: false,
      filters: {
        departamento_id: null,
        cargo_id: null,
        profissao_id: null,
        sig_uf: null,
        cod_munic: null
      },
      limit: 25,
      page: 1,
      totalRows: 0
    };
  },
  methods: {
    ...mapActions("notification", { notificate: "add" }),
    loadContatos(pageNumber) {
      ContatosService
        .getAll(this.limit, pageNumber, this.filters)
        .then(res => {
          this.contatos = res.data.data;
          this.contatosAll = res.data.dataAll;
          this.totalRows = res.data.totalRows;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    exportarContato() {
      const filters = Object.values(this.filters).every(value => value === null);
      const dados = filters ? this.contatosAll : this.contatos;
      const colunas = Object.keys(dados[0]);

      const linhas = [
        colunas.join(";"),
        ...dados.map(obj =>
          colunas.map(c => `"${(obj[c] ?? "").toString().replace(/"/g, '""')}"`).join(";")
        )
      ];

      const csv = linhas.join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "contatos_climb_admin.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportarContatosSpotter() {
      const filters = Object.values(this.filters).every(value => value === null);
      const dados = filters ? this.contatosAll : this.contatos;
      const colunas = Object.keys(dados[0]);

      const linhas = [
        colunas.join(";"),
        ...dados.map(obj =>
          colunas.map(c => `"${(obj[c] ?? "").toString().replace(/"/g, '""')}"`).join(";")
        )
      ];

      const xlsx = linhas.join("\n");
      const blob = new Blob([xlsx], { type: "text/xlsx;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "contatos_climb_spotter_admin.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    loadDepartamentos(pageNumber) {
      departamentosService
        .getAll(100, pageNumber, this.filters)
        .then(res => {
          this.departamentos = res.data.data
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    loadCargos(pageNumber) {
      cargosService
        .getAll(150, pageNumber, this.filters)
        .then(res => {
          this.cargos = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    loadProfissoes(pageNumber) {
      profissoesService
        .getAll(700, pageNumber, this.filters)
        .then(res => {
          this.profissoes = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    loadUf(pageNumber) {
      ufService
        .getAll(27, pageNumber, this.filters)
        .then(res => {
          this.uf = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    loadMunic(pageNumber) {
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));
      municService
        .getAll(853, pageNumber, this.filters)
        .then(res => {
          this.munic = res.data.data;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    abrirFiltros() {
      this.temporaryFilters = JSON.parse(JSON.stringify(this.filters));
      this.modalFiltro = true;
    },
    abrirExportar() {
      this.modalExportar = true;
    },
    filtrarContatos() {
      this.page = 1;
      this.modalFiltro = false;
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));
      this.loadContatos();
    },
    limparFiltros() {
      Object.keys(this.temporaryFilters).forEach(k => {
        this.temporaryFilters[k] = null;
      });
    },
  },
  components: {
    CList,
    CCard,
    CModal
  },
  computed: {
    optionsDepartamentos() {
      return this.departamentos.map(o => ({
        value: o.id,
        text: o.nome
      }));
    },
    optionsCargos() {
      return this.cargos.map(o => ({
        value: o.id,
        text: o.nome
      }));
    },
    optionsProfissoes() {
      return this.profissoes.map(o => ({
        value: o.id,
        text: o.nome
      }));
    },
    optionsUf() {
      return this.uf.map(o => ({
        value: o.sig_uf,
        text: o.nom_uf
      }))
    },
    optionsMunic() {
      return this.munic.map(o => ({
        value: o.cod_munic,
        text: o.nom_munic
      }))
    },
    totalFilters() {
      return Object.keys(this.filters).filter(
        k => this.filters[k] && this.filters[k] != ""
      ).length;
    }
  },
  mounted() {
    this.loadContatos(1);
    this.loadDepartamentos(1);
    this.loadCargos(1);
    this.loadProfissoes(1);
    this.loadUf(1);
  }
};
</script>